exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button[data-v-66819bbf]{margin-top:35px}.handle[data-v-66819bbf]{float:left}.close[data-v-66819bbf],.handle[data-v-66819bbf]{padding-top:8px;padding-bottom:8px}.close[data-v-66819bbf]{float:right}input[data-v-66819bbf]{display:inline-block;width:50%}.text[data-v-66819bbf]{margin:20px}", ""]);

// exports
